import { render } from "./BaseBadge.vue?vue&type=template&id=fdc58aa2&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=fdc58aa2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fdc58aa2"

export default script